module.exports = __webpack_public_path__ + "static/media/filter.34616648.svg";